import { tsrContractsClient } from './tsrContractsClient';

export const pmsClient = () => tsrContractsClient.apiPmsContract;
